import { ADD_FILTER, CLEAR_FILTER } from './actionType';

const initalState = {
    urlFetch: 'https://db.ygoprodeck.com/api/v7/cardinfo.php?type=effect%20monster,normal%20monster&num=50&offset=0'
}

const reducer = (state = initalState, action) => {
  switch (action.type) {
    case ADD_FILTER:
      return {
        ...state,
        urlFetch: initalState.urlFetch + action.payload
      }
    case CLEAR_FILTER:
      return {
        ...state,
        urlFetch: initalState.urlFetch
      }
    default:
      return state
  }
}

export default reducer